module.exports = new __parcel__URL__("nm8_chip.9b07a45c.png").toString();